import Header from './Header';
import Footer from './Footer';
import Sidebar from './Sidebar';
import ThemeCircle from './ThemeCircle';
import AppAlert from './AppAlert';
import AvailabilityForm from './AvailabilityForm'
import ActivityForm from './ActivityForm'
import Confirm from './Confirm'
import LoginForm from './LoginForm'
import CreateUser from './CreateUser'
import Bar from './SnackBar'
import UserExtratInfo from './UserExtratInfo'
import Vue from "vue";
import PersonForm from './PersonForm'

// register globally
Vue.component('CreateUser', CreateUser);
Vue.component('Header', Header);
Vue.component('Footer', Footer);
Vue.component('Sidebar', Sidebar);
Vue.component('ThemeCircle', ThemeCircle);
Vue.component('AppAlert', AppAlert);
Vue.component('AvailabilityForm', AvailabilityForm);
Vue.component('ActivityForm', ActivityForm);
Vue.component('Confirm', Confirm);
Vue.component('UserExtratInfo', UserExtratInfo);
Vue.component('PersonForm', PersonForm);
